<template>
  <div class="page-offset container">
    <h2 class="heading">
      {{ currentPage.template.content_title }}
    </h2>
    <SofieText
      class="prose-p:font-medium max-w-2xl"
      :value="currentPage.template.standard_text"
    />

    <div class="space-y-5 py-5 lg:space-y-6 lg:pb-20 lg:pt-12">
      <AmbitionList :ambitions="ambitions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {useAmbitionsQuery} from '~/graphql/graphql';

definePageMeta({
  auth: false,
  middleware: ['sofie-page'],
});

const currentPage = useSofiePage();

const {result} = useAmbitionsQuery();
const ambitions = computed(() => result.value?.ambitions);
</script>
